import { useMemo, useState } from 'react';

interface IParams {
  initialPrice: number;
  initialPayment: number;
  initialPeriod: number;
  minRate: number;
}

export const useMortgageFields = (initialValues: IParams) => {
  const { initialPrice, initialPeriod, minRate } = initialValues;

  const [price, setPrice] = useState(initialPrice);
  const [initialPayment, setInitialPayment] = useState(initialValues.initialPayment);
  const [paymentPeriod, setPaymentPeriod] = useState(initialPeriod);

  const initialPaymentPercent = useMemo(
    () => Math.min(100, Math.floor((initialPayment / price) * 100)),
    [initialPayment, price],
  );

  const { minPrice, maxPrice } = useMemo(() => {
    const minPrice = Math.min(1e5, initialPrice);
    const maxPrice = Math.max(5e7, initialPrice);

    return {
      minPrice,
      maxPrice,
    };
  }, [initialPrice]);

  return useMemo(
    () => ({
      price,
      initialPayment,
      paymentPeriod,
      initialPaymentPercent,
      maxPrice,
      minPrice,
      onPriceChange: setPrice,
      onInitialPaymentChange: setInitialPayment,
      onPaymentPeriodChange: setPaymentPeriod,
      minRate,
    }),
    [initialPayment, initialPaymentPercent, maxPrice, minPrice, paymentPeriod, price, minRate],
  );
};
